module.exports = __webpack_public_path__ + "static/media/submitter.df4e3c9a.svg";